import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ResizeService} from '../services/resize.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    ResizeService
  ]
})
export class ResizeModule { }
